import { useEffect, useState } from 'react'
import { gsap } from 'gsap'

export default function Loader() {
  const [isLoaded, setIsLoaded] = useState(false)
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const tl = gsap.timeline({
      onComplete: () => {
        setTimeout(() => setIsLoaded(true), 400)
      }
    })

    tl.to('.loader-line', {
      scaleX: 1,
      duration: 1.2,
      ease: 'power3.inOut',
      onUpdate: () => {
        const line = document.querySelector('.loader-line') as HTMLElement
        if (line) {
          const current = parseFloat(line.style.transform.replace('scaleX(', '').replace(')', ''))
          setProgress(Math.round(current * 100))
        }
      }
    })
    .to('.loader-text', {
      opacity: 1,
      y: 0,
      duration: 0.8,
      ease: 'power3.out'
    }, '-=0.6')
    .to('.loader-counter', {
      opacity: 1,
      duration: 0.5,
      ease: 'power2.out'
    }, '-=0.4')
    .to('.loader-counter', {
      opacity: 0,
      duration: 0.3,
      ease: 'power2.in'
    }, '+=0.8')
    .to('.loader-text', {
      opacity: 0,
      y: -20,
      duration: 0.4,
      ease: 'power2.in'
    }, '-=0.2')
    .to('.loader-overlay', {
      opacity: 0,
      duration: 0.6,
      ease: 'power2.inOut',
    }, '-=0.1')

    return () => {
      tl.kill()
    }
  }, [])

  if (isLoaded) return null

  return (
    <div className="loader-overlay fixed inset-0 z-[99999] bg-[#050505] flex items-center justify-center">
      <div className="relative flex flex-col items-center gap-8">
        
        <div className="loader-text opacity-0 translate-y-8">
            <img src="/images/logo.png" alt="" className='w-52'/>
        </div>

        <div className="w-48 h-px bg-white/10 overflow-hidden">
          <div 
            className="loader-line h-full bg-white origin-left"
            style={{ transform: 'scaleX(0)' }}
          />
        </div>

        <div className="absolute -top-20 -right-20 w-40 h-40 border border-white/5 rounded-full animate-pulse" />
        <div className="absolute -bottom-16 -left-16 w-32 h-32 border border-white/5 rounded-full animate-pulse" style={{ animationDelay: '0.5s' }} />
      </div>
    </div>
  )
}
